module.exports = __webpack_public_path__ + "db93a831ad18ced6be1cddab01a487e7.png";